import { z } from "zod";

export const regionSchema = z.object({
  code: z
    .string()
    .trim()
    .length(2, "Use the 2-letter ISO code (e.g. in, ae, us, sg)"),
  display_name: z.string().min(1, "Display name is required"),
  currency: z.string().trim().min(1, "Currency is required"),
  timezone: z.string().trim().min(1, "Timezone is required"),
  default_locale: z.string().trim().optional(),
  price_floor_minor: z.number().int().optional().nullable(),
  price_ceiling_minor: z.number().int().optional().nullable(),
  is_active: z.boolean().default(true),
  is_fallback: z.boolean().default(false),
});

export type RegionFormData = z.infer<typeof regionSchema>;
